import { render, staticRenderFns } from "./PictogramCalendarSVG.vue?vue&type=template&id=67b3f478"
import script from "./PictogramCalendarSVG.vue?vue&type=script&lang=js"
export * from "./PictogramCalendarSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports